import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@/environments/environment';
import { GaAccountModeReport, GaLocationReport, GaPlatformReport } from '../molecules/account-mode/account-mode.types';

@Injectable({
  providedIn: 'root',
})
export class AdminGoogleAnalyticsService {
  private readonly http = inject(HttpClient);
  private readonly api = environment.shout_api.url;

  getAccountMode(
    startDate = '7daysAgo',
    endDate = 'today',
  ): Observable<GaAccountModeReport> {
    return this.http.get<GaAccountModeReport>(`${this.api}/google-analytics/account-mode`, {
      params: { startDate, endDate },
    });
  }

  getPlatform(
    startDate = '7daysAgo',
    endDate = 'today',
  ): Observable<GaPlatformReport> {
    return this.http.get<GaPlatformReport>(`${this.api}/google-analytics/platform`, {
      params: { startDate, endDate },
    });
  }

  getLocations(
    startDate = '7daysAgo',
    endDate = 'today',
  ): Observable<GaLocationReport> {
    return this.http.get<GaLocationReport>(`${this.api}/google-analytics/locations`, {
      params: { startDate, endDate },
    });
  }
}
